<template>
  <v-alert
    border="left"
    colored-border
    color="accent"
    :class="`border--accent`"
  >
    <v-row>
      <v-col class="pl-sm-8">
        <div class="font-weight-bold">
          <span>Current Plan: </span>
          <span class="accent--text">
            {{ billing.planTypeName }}
          </span>
        </div>
        <div
          class="secondarytext--text"
          v-if="billing.planTypePricePerUser > 0"
        >
          ${{ billing.planTypePricePerUser }} user/month Billed Monthly
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="auto">
        <v-btn color="lighttext" text @click="cancelPlan">Cancel Plan</v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="auto"
        v-if="
          billing.planTypeId == $enums.companyPlanTypes.ENGAGEMENT ||
            billing.planTypeId == $enums.companyPlanTypes.LITE
        "
      >
        <v-btn color="accent" @click="changePlan">Upgrade</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CurrentPlanCard",
  data: () => ({}),
  computed: {
    ...mapGetters({ billing: "billing/billing" })
  },
  methods: {
    changePlan() {
      this.$emit("change");
    },
    cancelPlan() {
      this.$emit("cancel");
    }
  }
};
</script>
